"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatmap = exports.equals = exports.toArray = void 0;
var generic_1 = require("./generic");
var toArray = function (t) {
    if (Array.isArray(t))
        return t;
    else
        return [t];
};
exports.toArray = toArray;
var equals = function (t1, t2) {
    if (generic_1.noExist(t1) || generic_1.noExist(t2))
        return t1 === t2;
    var arr1 = exports.toArray(t1);
    var arr2 = exports.toArray(t2);
    if (arr1.length !== arr2.length)
        return false;
    var clone1 = Array.from(arr1).sort();
    var clone2 = Array.from(arr2).sort();
    for (var i = 0; i < clone1.length; ++i) {
        if (clone1[i] !== clone2[i])
            return false;
    }
    return true;
};
exports.equals = equals;
var flatmap = function () {
    var arr = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arr[_i] = arguments[_i];
    }
    return arr.reduce(function (p, c) { return p.concat.apply(p, exports.toArray(c)); }, []);
};
exports.flatmap = flatmap;
//# sourceMappingURL=array.js.map